export var FlittPaymentStatusEnum;
(function (FlittPaymentStatusEnum) {
    FlittPaymentStatusEnum["Created"] = "created";
    FlittPaymentStatusEnum["Processing"] = "processing";
    FlittPaymentStatusEnum["Declined"] = "declined";
    FlittPaymentStatusEnum["Approved"] = "approved";
    FlittPaymentStatusEnum["Expired"] = "expired";
    FlittPaymentStatusEnum["Reversed"] = "reversed";
})(FlittPaymentStatusEnum || (FlittPaymentStatusEnum = {}));
//# sourceMappingURL=flitt-payment-status.enum.js.map